import React from 'react';
import { useTranslation } from 'react-i18next';
import { css } from 'styled-components';
import { useForm, useFormState } from 'react-final-form';
import { CATEGORY_ROOMS } from '../../../../../utils/helpers/constants';
import { FiltersOptionsWrapper } from '../styled';
import { FiltersSection } from '../FiltersSection';
import { Chips } from '../../../../ui/Chips';

export const chipsStyles = css`
  width: 44px;
  height: 44px;
  justify-content: center;
  padding: 0;

  &[data-active='true'] {
    border-color: #4264fd;
    background-color: #4264fd;
    color: #fff;
  }
`;

export const NewSearchRooms = () => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();

  const roomIds = Array.isArray(values.room_ids) ? values.room_ids : [];

  const handleChangeOption = (room: string) => {
    const nextRooms = new Set(roomIds);
    if (nextRooms.has(room)) {
      nextRooms.delete(room);
    } else {
      nextRooms.add(room);
    }
    change('room_ids', Array.from(nextRooms));
  };

  return (
    <FiltersSection title={t('search.form.rooms_number')}>
      <FiltersOptionsWrapper>
        {CATEGORY_ROOMS.map(room => (
          <Chips
            key={`room-${room}`}
            text={room}
            value={room}
            type="button"
            hasCustomOnChange
            storedValue={roomIds}
            onClick={() => handleChangeOption(room)}
            styles={chipsStyles}
            stat={`new-search-form-${room}-rooms`}
            cypress="rooms-chip-text"
          />
        ))}
      </FiltersOptionsWrapper>
    </FiltersSection>
  );
};
